import { wsService } from "./wsService";

const section = "inventory-operation";

function filter(param) {
  return wsService.make_post_request(section + "/list", param);
}

function create(param = {}) {
  return wsService.make_post_request(section + "/create", param);
}

function getOpTypes() {
  return wsService.make_post_request(section + "/get_op_types");
}

function getAllDocumentTypes(param = {}) {
  return wsService.make_post_request(section + "/get_all_document_types", param);
}


function getStockTypes() {
  return wsService.make_post_request(section + "/get_stock_types");
}

export const inventoryOperationService = {
  section,
  filter,
  create,
  getOpTypes,
  getAllDocumentTypes,
  getStockTypes
};
